import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};



const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};
export const Articles = () => {

  const [articles, setArticles] = useState([]);

  useEffect(() => {
    fetch("/rna.txt")
      .then(res => res.text())
      .then(text => {

        const lines = text.split("\n");

        const data = lines
          .filter(line => line.trim() !== "" && line.includes("|"))
          .map(line => {
            const parts = line.split("|");

            return {
              date: parts[0].trim(),
              caption: parts[1].trim(),
              content: parts[2].trim(),
              image: parts[4].trim(),
              file: parts[3].trim()
            };
          })
          .reverse();

        setArticles(data);
      });

  }, []);

  return (
    <div className="container  " style={{ padding: "130px 0 60px", }}>
      <motion.div
        className="text-center mb-5 px-3"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={containerVariants}
      >
        <motion.div variants={fadeInUp}>
          <span className="d-inline-block px-4 py-2 rounded-pill mb-3"
            style={{
              color: "var(--gold)",
              fontWeight: "600",
              letterSpacing: "2px",
              fontSize: "0.9rem",
              textTransform: "uppercase",
              border: "1px solid var(--gold-light)",
              background: "rgba(184, 134, 11, 0.05)",
              backdropFilter: "blur(4px)"
            }}
          >
            Articles & Important News
          </span>


          <motion.h4
            className="fw-bold display-6 display-md-5 mt-2"
            variants={fadeInUp}
            style={{
              fontFamily: "'Playfair Display', serif",
              fontWeight: 600,
              color: 'var(--primary-dark)',
              background: "linear-gradient(135deg, var(--primary-dark) 0%, var(--gold) 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text"
            }}
          >
            Latest Articles & Important News
          </motion.h4>

        </motion.div>
      </motion.div>
      <div className="container-fluid">
        {articles.map((item, index) => (
          <div key={index} className="border-bottom py-4">

            <div className="row align-items-start">

              {/* Left: Content */}
              <div className="col-md-8">

                {/* Date */}
                <small className="text-muted d-block mb-2">
                  <i className="bi bi-calendar3 me-2"></i>
                  {item.date}
                </small>

                {/* Title */}
                <h4 className="fw-semibold mb-2">
                  {item.caption}
                </h4>

                {/* Content */}
                <p className="text-muted mb-3">
                  {item.content}
                </p>

                {/* Button */}
                <a
                  href={item.file}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-primary btn-sm"
                >
                  <i className="bi bi-file-earmark-pdf me-2"></i>
                  View PDF
                </a>

              </div>

              {/* Right: Image */}
              <div className="col-md-4">
                <img
                  src={item.image}
                  alt={item.caption}
                  className="img-fluid rounded"
                 
                  onError={(e) => (e.target.src = "/no-image.png")}
                />
              </div>

            </div>

          </div>
        ))}
      </div>
    </div>
  );
};

